import { render, staticRenderFns } from "./OilPalmMap3D.vue?vue&type=template&id=148ddd88&"
import script from "./OilPalmMap3D.vue?vue&type=script&lang=js&"
export * from "./OilPalmMap3D.vue?vue&type=script&lang=js&"
import style0 from "./OilPalmMap3D.vue?vue&type=style&index=0&id=148ddd88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports